import { styled } from "@mui/material";
import { Box } from "@mui/system";
import { IconButton } from "@pmag/ui-components";
import { type HTMLAttributes } from "react";

export interface ExplosionGraphicHotspotProps extends HTMLAttributes<HTMLDivElement> {
    height: string;
    left: string;
    top: string;
    width: string;
}

export const BoxZoomContainer = styled(Box)(({ theme }) => ({
    marginTop: theme.spacing(4),
    width: "100%",
    height: "60vh",
    position: "relative",
    overflow: "hidden",
    border: `1px solid ${theme.palette.core.grey._30}`,
    borderRadius: theme.shape.borderRadius,

    "& .react-transform-wrapper": {
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
        WebkitTouchCallout: "none" /* iOS Safari */,
        WebKitUserSelect: "none" /* Safari */,
        KhtmlUserSelect: "none" /* Konqueror HTML */,
        MozUserSelect: "none" /* Firefox */,
        MsUserSelect: "none" /* Internet Explorer/Edge */,
        userSelect: "none",
        margin: 0,
        padding: 0,
    },

    "& .react-transform-component": {
        display: "flex",
        flexWrap: "wrap",
        width: "fit-content",
        height: "fit-content",
        margin: 0,
        padding: 0,
        transformOrigin: "0% 0%",
    },
}));

export const BoxActions = styled(Box)(({ theme }) => ({
    position: "absolute",
    right: theme.spacing(3),
    top: theme.spacing(3),
    zIndex: 1,
    display: "flex",
    flexDirection: "row",
    boxShadow: theme.shadows[1],
    borderRadius: theme.shape.borderRadius,
    background: theme.palette.core.white,
    border: `1px solid ${theme.palette.core.grey._30}`,
}));

export const IconButtonRightBorder = styled(IconButton)(({ theme }) => ({
    borderRadius: "unset",
    borderRight: `1px solid ${theme.palette.core.grey._30}`,
}));

export const ExplosionGraphicImage = styled("img")(() => ({
    pointerEvents: "none",
}));

export const ExplosionGraphicHotspots = styled(Box)(() => ({
    position: "absolute",
    inset: 0,
}));

export const ExplosionGraphicHotspot = styled(Box)<ExplosionGraphicHotspotProps>(({ theme, left, top, width, height }) => ({
    position: "absolute",
    cursor: "pointer",
    borderRadius: "100%",
    transform: "translate(8%, -6%)",
    left,
    top,
    width,
    height,
    "&:hover": {
        boxShadow: `0 0 0 2px ${theme.palette.blue._50}, inset 0 0 0 1px ${theme.palette.blue._50}`,
    },
    "& > span": {
        position: "absolute",
        top: "0",
        left: "0",
        width: "100%",
        height: "100%",
    },
}));

export const ExplosionGraphicHotspotGhost = styled(Box)(() => ({
    position: "absolute",
    inset: 0,
}));

export const BoxTooltip = styled(Box)(({ theme }) => ({
    minWidth: 350,
    margin: `-${theme.spacing(6)}`,
}));
